import {Injectable, Injector} from '@angular/core';

@Injectable()
export class AuthService {
  constructor(
    injector: Injector
  ) {
  }

  checkLogin() {

  }

}
